// @flow
import { selectSODashboardFlag } from '../stores/launchDarkly';
import GET_SO_DASHBOARD_DATA_QUERY from '../queries/newSODashboard/getSODashboardDataQuery.graphql';

const sODashboardLoader = ({ getState, apolloClient }) => {
  const isSODashboardEnabled = selectSODashboardFlag(getState());

  if (isSODashboardEnabled) {
    return apolloClient.query({
      query: GET_SO_DASHBOARD_DATA_QUERY,
      variables: {
        listingsOffset: 0
      },
      fetchPolicy: 'network-only'
    });
  }
  return null;
};

export default sODashboardLoader;
